<prcins-es-popup headerClass="bg-es-blue text-white" *ngIf="true" class="small-popup">
  <div header-left>
    <div class="bg-es-blue text-white px-4 py-3 rounded-t">
      <span>Update Your Contact Information</span>
    </div>
  </div>
  <div body>
    <p class="mb-4">Thank you for being a loyal customer. To help us serve you better, please provide your preferred contact phone number and email address.</p>
    <form [formGroup]="contactForm" class="contact-form-narrow">
      <div *ngIf="errorMessage" class="text-red-500 text-sm mb-4">{{ errorMessage }}</div>
      <div class="mb-4">
        <label for="phoneNumber" class="block text-gray-700 font-bold mb-2">Phone Number</label>
        <div class="flex items-center">
          <input type="tel" id="phoneNumber" formControlName="phoneNumber" class="phone-field px-3 py-2 border rounded-lg"
            [ngClass]="{ 'border-red-500': contactForm.get('phoneNumber').invalid && contactForm.get('phoneNumber').touched }">
          <input type="checkbox" id="mobileIndicator" formControlName="mobileIndicator" class="ml-4 mr-2">
          <label for="mobileIndicator" class="text-gray-700 mobile-label">This is a mobile number</label>
        </div>
        <div *ngIf="contactForm.get('phoneNumber').invalid && contactForm.get('phoneNumber').touched" class="text-red-500 text-sm mt-1">
          A valid phone number is required.
        </div>
      </div>
      <div class="mb-4">
        <label for="email" class="block text-gray-700 font-bold mb-2">Email Address</label>
        <input type="email" id="email" formControlName="email" class="email-field px-3 py-2 border rounded-lg"
          [ngClass]="{ 'border-red-500': contactForm.get('email').invalid && contactForm.get('email').touched }">
        <div *ngIf="contactForm.get('email').invalid && contactForm.get('email').touched" class="text-red-500 text-sm mt-1">
          A valid email is required.
        </div>
      </div>
      <div class="mb-6 flex items-center">
        <input type="checkbox" id="doNotShowAgain" formControlName="doNotShowAgain" class="mr-2">
        <label for="doNotShowAgain" class="text-gray-700">Do not show this again</label>
      </div>
      <div class="flex justify-end">
        <button type="button" (click)="onCancel()" class="es-btn-secondary mr-2">Cancel</button>
        <button type="button" (click)="onSubmit()" [disabled]="contactForm.invalid" class="es-btn-primary">Submit</button>
      </div>
    </form>
  </div>
</prcins-es-popup>